'use strict';
export default function DataModelProfiler() {
	this.propertyChanged = propertyChanged;
	this.arrayChanged = arrayChanged;
	this.sourceExecuted = sourceExecuted;
	this.sourceTriggered = sourceTriggered;
	this.sourceExecuting = sourceExecuting;
	this.sourceRejected = sourceRejected;
	this.logDataModelCleanup = logDataModelCleanup;

	function log(header, innerLogs) {
		if (mx.__mx$dataModelProfilingOn || mx.__mx$dataModelProfilingOn_PROD) {
			var groupMethod = mx.__mx$dataModelProfilingOn_PROD ? console.group : console.groupCollapsed;
			if (groupMethod) {
				header[0] = 'mx-debug #dataModel. ' + header[0];
				groupMethod.apply(console, header);
				innerLogs.forEach(function (innerLogItem) {
					var output = mx.__mx$dataModelProfilingOn_PROD ? JSON.stringify(innerLogItem) : innerLogItem;
					if (Array.isArray(output)) {
						console.log.apply(console, output);
					} else {
						console.log(output);
					}
				});
				console.groupEnd();
			} else {
				console.log.apply(console, ['mx-debug #dataModel. ' + header].concat(innerLogs));
			}
		}
	}

	function logDataModelCleanup(widgetInstanceTitle, { removedProperties, cleanedObject, availableProperties } = {}) {
		if (mx.__mx$dataModelProfilingCleanupWidgetConfiguration) {
			const propertiesRemoved = Object.keys(removedProperties).length;
			if (propertiesRemoved === 0) {
				return;
			}
			console.groupCollapsed(`CleanUp Widget (removed %c${propertiesRemoved}%c properties): %c${widgetInstanceTitle}`, 'color:orange', 'color:auto', 'color:orange');
			console.log('Removed Properties', removedProperties);
			console.log('Available Properties', availableProperties);
			console.log('Cleaned object', cleanedObject);
			console.groupEnd();
		}
	}

	function propertyChanged(calcValue, calcProperty, triggeredBy, meta) {
		var logs = [];

		logs.push(['New Value:', calcValue.value]);
		logs.push(['Old Value:', calcValue.oldValue]);
		logs.push(['Calc Value Object:', calcValue]);
		logs.push(['Property Descriptor:', calcProperty]);
		logs.push(['Execution options:', meta]);

		var headerColors = [];
		var formattedValue = calcValue.value ? calcValue.value.toString() : calcValue.value;
		if (formattedValue !== null && formattedValue !== undefined && formattedValue.length > 36) {
			formattedValue = formattedValue.substring(0, 20) + '...';
		}
		var header = ' --- %c[property changed]: %c' + calcProperty.descriptor.Path + '%c = ' + formattedValue;

		if (triggeredBy) {
			header = header + ' %c<--- triggered by: %c' + triggeredBy;
		}
		headerColors.push('color:green'); // color for --- [prop changed]
		headerColors.push('color:black'); // color for path
		headerColors.push('color:gray'); // color for path

		if (triggeredBy) {
			headerColors.push('color:darkgray'); // color for triggered path
			headerColors.push('color:gray'); // color for triggered arrow
		}

		log([header].concat(headerColors), logs);
	}

	function arrayChanged(calcProperty, fnName) {
		var header = ' --- %c[array changed `' + fnName + '` function]: %c' + calcProperty.descriptor.Path;
		log([header, 'color:green', 'color:black'], [calcProperty]);
	}

	function sourceExecuted(sourceName, newData, modelSourceData) {
		log(
			['%c[SOURCE_EXECUTED]: %c' + sourceName, 'color: red', 'color: black'],
			[
				['Response Data: ', newData],
				['ResultSourceData: ', modelSourceData],
			]
		);
	}

	function sourceTriggered(sourceName, inactive, triggeredBy, sourceData) {
		var headerMsg = inactive ? 'SOURCE_INACTIVE' : 'SOURCE_TRIGGERED';
		var headerMsgColor = inactive ? 'darkgray' : 'blue';

		var header = '%c[' + headerMsg + ']: %c' + sourceName;
		var headerColors = [];
		if (triggeredBy) {
			header += ' %c<--- %c' + triggeredBy;
		}

		headerColors.push('color:' + headerMsgColor + '');
		headerColors.push('color:black');

		if (triggeredBy) {
			headerColors.push('color:gray');
			headerColors.push('color:darkgray');
		}
		log([header].concat(headerColors), [['Source Data: ', sourceData]]);
	}

	function sourceExecuting(sourceName, url, data) {
		log(['%c ... [executing]: %c' + sourceName + '%c URL: %c' + url, 'color:blue', 'color:black', 'color:gray', 'color:darkcyan'], [['Request data: ', data]]);
	}
	function sourceRejected(sourceName, msg) {
		log(['%c[SOURCE_REJECTED]: %c' + sourceName, 'color: darkred', 'color:black'], [[msg, 'darkred']]);
	}
}
